import { clsx } from 'clsx'
import { ReactNode } from 'react'
import css from './RoundButton.module.scss'

type Props = {
  onClick?: () => void
  children?: ReactNode
  className?: string
}

export function RoundButton(props: Props) {
  const { children, onClick } = props
  const className = clsx(props.className, css.button)

  return <div className={className} onClick={onClick}>
    {children}
  </div>
}
